import codes from "./codes";
import logs from "./logs";

export const attendance = {
    codes,
    logs,
};

export default attendance;
